
import Vue from 'vue'

export default Vue.extend({
    name: 'LocateLead',
    components: {
    },
    computed: {
    },
    data(){
        return{
        }
    },
    methods: {
    },
    mounted() {
    }
})
